import { AbstractControl } from '@angular/forms';

export function forbiddenEmailValidator(control:AbstractControl): {[key: string]: any} | null {
    const address = /\w+@\w+[.]\w+$/.test(control.value) === false;

    return address ? { 'forbiddenEmail': {value: control.value}} : null;
}

export function addressValidator(control:AbstractControl): {[key: string]: any} | null {
    const address = /\d+\s(\w+[,.]?\s)?\w+\s[a-zA-Z]+[,.]*?\s?([#]?\w+[,.]?)?/.test(control.value) === false

    return address ? { 'forbiddenAddress': {value: control.value}} : null
}

export function priceValidator(control:AbstractControl): {[key: string]: any} | null {
    const price = /^\d+/.test(control.value) === false

    return price ? { 'forbiddenPrice': {value: control.value}} : null
}